export const powerSum = (num: number, power: number): number => {
  if (power <= 0) return num ** power;

  return num ** power + powerSum(num, power - 1);
};
